module.exports = __webpack_public_path__ + "static/img/congratulation.4e52b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dial/img/congratulation.png
// module id = 9WpF
// module chunks = 1